import { render } from "./ProductLandingItem.vue?vue&type=template&id=391fef20"
import script from "./ProductLandingItem.vue?vue&type=script&lang=js"
export * from "./ProductLandingItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__